import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-gamepass-interim',
  templateUrl: './gamepass-interim.component.html',
  styleUrls: ['./gamepass-interim.component.scss'],
})
export class GamepassInterimComponent implements OnInit {
  type: '1' | '2' | '3' = '3';
  locale: string = 'en';

  selectedGameMode: 'outdoor' | 'indoor' | 'event-hall' = 'outdoor';

  virtualLogos = [
    './assets/images/clients/coca.png',
    './assets/images/clients/microsoft.jpg',
    './assets/images/clients/uber.svg',
    './assets/images/clients/morgan_stanley.png',
  ];

  ngOnInit(): void {
    // Only show this page on mobile viewports; otherwise go back to normal redirect
    const isMobileViewport = window.matchMedia('(max-width: 991.98px)').matches;
    if (!isMobileViewport) {
      this.router.navigate(['/gamepass-redirect'], { queryParams: { type: this.type, locale: this.locale } });
      return;
    }

    this.route.queryParams.subscribe((params) => {
      const type = params.type as '1' | '2' | '3';
      const locale = (params.locale as string) || 'en';

      if (!type || !['1', '2', '3'].includes(type)) {
        // If missing/invalid, fall back to outdoor
        this.type = '3';
      } else {
        this.type = type;
      }
      this.locale = locale;

      this.selectedGameMode = this.typeToMode(this.type);
    });
  }

  constructor(private route: ActivatedRoute, private router: Router) {}

  get leftPanelCopy(): { title: string; tagline: string; description: string } {
    const copyMap = {
      outdoor: {
        title: 'Flinkit Outdoor',
        tagline: 'Turn any city into a team challenge!',
        description:
          'Create and manage super fun, location-based games and events that boost engagement, increase revenue, and reduce operational effort — all in the browser.',
      },
      indoor: {
        title: 'Flinkit Indoor',
        tagline: 'Turn any venue into a team challenge!',
        description:
          'Run indoor, room-to-room experiences for museums, exhibitions, and team events — with guided challenges that keep groups moving and engaged.',
      },
      'event-hall': {
        title: 'Flinkit Event Hall',
        tagline: 'Turn your event hall into a live team challenge!',
        description:
          'Power conferences and event halls with interactive challenges that drive booth traffic, spark conversations, and make engagement measurable.',
      },
    } as const;

    return copyMap[this.selectedGameMode] ?? copyMap.outdoor;
  }

  setGameMode(mode: 'outdoor' | 'indoor' | 'event-hall') {
    this.selectedGameMode = mode;
    this.type = this.modeToType(mode);
  }

  startDemo() {
    // Go to normal redirect but bypass mobile interception
    this.router.navigate(['/gamepass-redirect'], {
      queryParams: {
        type: this.type,
        locale: this.locale,
        forceRedirect: '1',
      },
    });
  }

  private typeToMode(type: '1' | '2' | '3'): 'outdoor' | 'indoor' | 'event-hall' {
    if (type === '1') return 'event-hall';
    if (type === '2') return 'indoor';
    return 'outdoor';
  }

  private modeToType(mode: 'outdoor' | 'indoor' | 'event-hall'): '1' | '2' | '3' {
    if (mode === 'event-hall') return '1';
    if (mode === 'indoor') return '2';
    return '3';
  }
}


